import { getAgpApiUrl, smb_fetch } from '@/api/operator/fetch';

// 客服 iframe 链接
const getPersonalData = (data) => {
  const url = getAgpApiUrl('ad_tool_service/qidian_reception', 'get');
  const params = $.extend(
    true,
    {
      method: 'POST',
      contentType: 'application/json',
    },
    { data },
  );
  return smb_fetch(url, params, true, false);
};

const getTipData = (data) => {
  const url = getAgpApiUrl('ad_tool_service/qidian_unread_msg', 'get');
  const params = $.extend(
    true,
    {
      method: 'POST',
      contentType: 'application/json',
    },
    { data },
  );
  return smb_fetch(url, params, false, false);
};

export default {
  getPersonalData,
  getTipData,
};
